import { memo } from 'react';
import Markdown from 'react-markdown';
import styled from '@emotion/styled';

type Props = {
  content: string;
};

/**
 * A generic tooltip component that renders markdown content.
 * Used for displaying chart tooltips with custom templates.
 */
export const TemplateTooltip = memo(({ content }: Props) => {
  return (
    <Root>
      <Markdown
        components={{
          // Customize markdown rendering for tooltip context
          p: ({ children }) => <p style={{ margin: 0 }}>{children}</p>,
          strong: ({ children }) => <Strong>{children}</Strong>,
          em: ({ children }) => <Em>{children}</Em>,
        }}
      >
        {content}
      </Markdown>
    </Root>
  );
});

const Root = styled.div`
  background: white;
  padding: 9px 12px;
  border: 1px solid #ccc;
  max-width: 400px;
  width: max-content;
  font-size: 14px;
  line-height: 1.4;
  overflow-wrap: break-word;
`;

const Strong = styled.strong(({ theme }) => ({
  fontFamily: theme.fonts?.semiBold ?? 'inherit',
}));

const Em = styled.em`
  font-style: italic;
`;
